export const MAIL_LOCATION = 'Owa mail React';
export const ERROR_DIALOG_LOCATION = 'ErrorDialog React';
export const CALENDAR_READFORM_LOCATION = 'Owa calendar readform React';
export const TEAM = 'Team 1';
export const OWA = 'owa';

export const DEFAULT_LOADING_VIEW = 'resources/animations/Default_Loading.gif';
export const TRAVEL_LOADING_VIEW = 'resources/animations/Travel_Loading.gif';
export const PACKAGE_LOADING_VIEW = 'resources/animations/Package_Loading.gif';
export const DINING_LOADING_VIEW = 'resources/animations/Dining_Loading.gif';
export const EVENT_LOADING_VIEW = 'resources/animations/Event_Loading.gif';
export const INVOICE_LOADING_VIEW = 'resources/animations/Invoice_Loading.gif';

export const DEFAULT_LOADING_STATIC_VIEW = 'resources/images/Default_Loading_Static.png';
export const TRAVEL_LOADING_STATIC_VIEW = 'resources/images/Travel_Loading_Static.png';
export const PACKAGE_LOADING_STATIC_VIEW = 'resources/images/Package_Loading_Static.png';
export const DINING_LOADING_STATIC_VIEW = 'resources/images/Dining_Loading_Static.png';
export const EVENT_LOADING_STATIC_VIEW = 'resources/images/Event_Loading_Static.png';
export const INVOICE_LOADING_STATIC_VIEW = 'resources/images/Invoice_Loading_Static.png';

export const FLIGHT_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Flight_378.svg';
export const FLIGHT_ILLUSTRATION = 'resources/images/TXP_1color_Flight_378.svg';
export const FLIGHT_ILLUSTRATION_DARK_THEME = 'resources/images/TXP_darktheme_Flight_378.svg';
export const FLIGHT_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_Flight.svg';
export const FLIGHT_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Flight.svg';
export const LODGING_ILLUSTRATION = 'resources/images/TXP_1color_Hotel_378.svg';
export const LODGING_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Hotel_378.svg';
export const LODGING_ILLUSTRATION_DARK_THEME = 'resources/images/TXP_darktheme_Hotel_378.svg';
export const LODGING_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_Hotel.svg';
export const LODGING_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Hotel.svg';
export const PARCEL_DELIVERY_ILLUSTRATION = 'resources/images/TXP_1color_Delivery_378.svg';
export const PARCEL_DELIVERY_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Delivery_378.svg';
export const PARCEL_DELIVERY_ILLUSTRATION_DARK_THEME =
    'resources/images/TXP_darktheme_Delivery_378.svg';
export const PARCEL_DELIVERY_ILLUSTRATION_WIDE_TRICOLOR =
    'resources/images/TXP_3color_Delivery.svg';
export const PARCEL_DELIVERY_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Delivery.svg';
export const RENTAL_CAR_ILLUSTRATION = 'resources/images/TXP_1color_CarRental_378.svg';
export const RENTAL_CAR_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_CarRental_378.svg';
export const RENTAL_CAR_ILLUSTRATION_DARK_THEME =
    'resources/images/TXP_darktheme_CarRental_378.svg';
export const RENTAL_CAR_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_CarRental.svg';
export const RENTAL_CAR_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_CarRental.svg';
export const EVENT_ILLUSTRATION = 'resources/images/TXP_1color_Tickets_378.svg';
export const EVENT_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Tickets_378.svg';
export const EVENT_ILLUSTRATION_DARK_THEME = 'resources/images/TXP_darktheme_Tickets_378.svg';
export const EVENT_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_Tickets.svg';
export const EVENT_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Tickets.svg';
export const DINING_ILLUSTRATION = 'resources/images/TXP_1color_Dining_378.svg';
export const DINING_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Dining_378.svg';
export const DINING_ILLUSTRATION_DARK_THEME = 'resources/images/TXP_darktheme_Dining_378.svg';
export const DINING_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_Dining.svg';
export const DINING_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Dining.svg';
export const INVOICE_ILLUSTRATION = 'resources/images/TXP_1color_Invoice_378.svg';
export const INVOICE_ILLUSTRATION_TRICOLOR = 'resources/images/TXP_3color_Invoice_378.svg';
export const INVOICE_ILLUSTRATION_DARK_THEME = 'resources/images/TXP_darktheme_Invoice_378.svg';
export const INVOICE_ILLUSTRATION_WIDE_TRICOLOR = 'resources/images/TXP_3color_Invoice.svg';
export const INVOICE_ILLUSTRATION_WIDE = 'resources/images/TXP_1color_Invoice.svg';
export const SERVICE_RESERVATION_ILLUSTRATION =
    'resources/images/TXP_1color_ServiceReservation_378.svg';
export const SERVICE_RESERVATION_ILLUSTRATION_TRICOLOR =
    'resources/images/TXP_3color_ServiceReservation_378.svg';
export const SERVICE_RESERVATION_ILLUSTRATION_DARK_THEME =
    'resources/images/TXP_darktheme_ServiceReservation_378.svg';
export const SERVICE_RESERVATION_ILLUSTRATION_WIDE =
    'resources/images/TXP_1color_ServiceReservation.svg';
export const SERVICE_RESERVATION_ILLUSTRATION_WIDE_TRICOLOR =
    'resources/images/TXP_3color_ServiceReservation.svg';

export const MAX_LOADING_TIME = 15000;

export const FLIGHTS_ENTITY_NAMES_MAP_VALUE = 1;
export const DINING_ENTITY_NAMES_MAP_VALUE = 2;
export const LODGING_ENTITY_NAMES_MAP_VALUE = 4;
export const LODGING_AND_CAR_ENTITY_NAMES_MAP_VALUE = 12;
export const LODGING_AND_FLIGHTS_AND_CAR_ENTITY_NAMES_MAP_VALUE = 13;
export const RENTAL_CAR_ENTITY_NAMES_MAP_VALUE = 8;
export const PACKAGE_ENTITY_NAMES_MAP_VALUE = 16;
export const EVENTS_ENTITY_NAMES_MAP_VALUE = 32;
export const INVOICE_ENTITY_NAMES_MAP_VALUE = 64;
export const SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE = 128;
export const UNSUCCESSFUL_FLIGHTS_ENTITY_NAMES_MAP_VALUE = 4294967296;
export const UNSUCCESSFUL_LODGING_ENTITY_NAMES_MAP_VALUE = 8589934592;
export const UNSUCCESSFUL_RENTAL_ENTITY_NAMES_MAP_VALUE = 17179869184;

export const PRIMARY_COLOR = 'primary';
export const DARKER_COLOR = 'darker';
export const LIGHTER_COLOR = 'lighter';
export const LIGHT_COLOR = 'light';
